import React from "react";
import { localizer } from '../../../Translator'

import { Grid } from "@material-ui/core";
import Checkbox from '@material-ui/core/Checkbox';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Typography } from "@material-ui/core"
import IconButton from '@material-ui/core/IconButton'
import { Button } from "@material-ui/core"

import { TableRowStyled, TableCellStyled } from '../../common/TableStyled.js'

import AuthCli from '../../../sdk/AuthCli'

export class EmailAddress extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

      // Flag to open/close delete email address modal
      openDeleteModal: false,

      // Represents dynamic message to delete an email address depending its settings
      deleteEmailMessage: "",

      // Email stored without special characters
      emailNormalized: "",

      // Currently email user logged 
      currentSessionEmail: null,
    }
  }

  /* Setting normalized email in case it is not validated yet */
  componentDidMount() {
    if (this.props.email) {
      let emailNormalized = this.props.email.startsWith("*") ? this.props.email.substring(1) : this.props.email
      this.setState({ emailNormalized: emailNormalized })
      // Get email user.
      AuthCli.GetSessionInfo().then(session => {
        if (session) {
          this.setState({ currentSessionEmail: session.userEmail.toLowerCase() })
        }
      })

    }
  }

  /* Posible actions to do with a email address */
  doCertificateReceiver = () => {
    let email = this.props.email === this.props.certificateEmail ? "" : this.state.emailNormalized
    this.props.handleEmail(email, "SETASCERTIFICATE")
  }

  doEmissionReceiver = () => {
    let email = this.props.email === this.props.emissionEmail ? "" : this.state.emailNormalized
    this.props.handleEmail(email, "SETASEMISSION")
  }

  doDeleteEmail = () => {
    this.props.handleEmail(this.state.emailNormalized, "DELETE")
  }

  /* Handle modal open/close events */
  doOpenDeleteModal = () => {
    var message = localizer.EmailAddressConfirmDeleteMessage
    if (this.state.emailNormalized === this.props.certificateEmail || this.state.emailNormalized === this.props.emissionEmail) {
      message = localizer.EmailAddressNotConfirmDeleteMessage
    }
    this.setState({ openDeleteModal: true, deleteEmailMessage: message })
  }

  doCloseDeleteModal = () => {
    this.setState({ openDeleteModal: !this.state.openDeleteModal })
  }


  render() {

    const isValidated = !this.props.email.startsWith("*")
    const isCertificateReceiver = this.props.email === this.props.certificateEmail
    const isEmissionReceiver = this.props.email === this.props.emissionEmail

    return (
      <React.Fragment>
        <TableRowStyled className={this.state.currentSessionEmail === this.props.email ? "current-email":""}>
          <TableCellStyled align="center" className={isValidated ? "email-validated" : "email-not-validated"}>
            {isValidated ?
              <i className="fa-solid fa-envelope-circle-check font-size-25 color-lightgreen " title={localizer.EmailAddressValidated}></i> :
              <i className="fa-solid fa-envelope font-size-25 color-darkred" title={localizer.EmailAddressValidated}></i>
            }
          </TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">{this.state.emailNormalized}</TableCellStyled>
          <TableCellStyled className="typography-generic tablerow-content" align="center">
            {isValidated ? localizer.EmailAddressValidated : localizer.EmailAddressPendingValidation}
          </TableCellStyled>
          <TableCellStyled align="center">
            <Checkbox
              checked={isCertificateReceiver}
              onChange={this.doCertificateReceiver}
              icon={<i className="fa-regular fa-square font-size-25 color-ultralightgreen"></i>}
              checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-ultralightgreen"></i>} />
          </TableCellStyled>
          <TableCellStyled align="center">
            <Checkbox
              checked={isEmissionReceiver}
              onChange={this.doEmissionReceiver}
              icon={<i className="fa-regular fa-square font-size-25 color-ultralightgreen"></i>}
              checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-ultralightgreen"></i>} />
          </TableCellStyled>
          {this.state.currentSessionEmail !== this.props.email ?
            <TableCellStyled align="center">
              <IconButton className="button-generic icon-button" aria-label="delete" onClick={this.doOpenDeleteModal}>
                <i className="fa-solid fa-trash-can"></i>
              </IconButton>
            </TableCellStyled>
            :
            <TableCellStyled></TableCellStyled>
          }
        </TableRowStyled>
        
        <Dialog
          open={this.state.openDeleteModal}
          onClose={this.doCloseDeleteModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"sm"}
        >
          <DialogTitle id="alert-dialog-title">
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.doCloseDeleteModal}></i>
            <Typography className="typography-generic dialog-title" >{localizer.EmailAddressDeleteEmail}</Typography>
          </DialogTitle>
          <DialogContent dividers={true} className="dialog-content">
            <Grid container direction="row" spacing={4} className="mt-10">
              <Grid container item md={12} direction="row" spacing={2}>
                <Typography className="typography-generic">{this.state.deleteEmailMessage}</Typography>
              </Grid>
              <Grid container item md={12} direction="row" spacing={2} justify="flex-end" className="mt-10">
                <Button className="button-generic dialog-cancel" variant="outlined" onClick={this.doCloseDeleteModal}>{localizer.Cancel}</Button>
                <Button className="button-generic dialog-delete" variant="contained" onClick={this.doDeleteEmail} disabled={isCertificateReceiver || isEmissionReceiver}>{localizer.EmailAddressDelete}</Button>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/email-address/sections/EmailAddress.js